import { Button, Col, Modal, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const FollowRequiredModal = ({ visible, onClose, teamName, feature }) => {
  const { t } = useTranslation();
  const { isMobile } = useSelector((state) => state.appState);

  return (
    <Modal
      visible={visible}
      closeModal={onClose}
      wid={isMobile ? '320px !important' : 'auto !important'}
    >
      <Col pad="32px 42px" center wid="100%" maxWid="400px" marg="0 auto" boxSizing="border-box">
        <Col centerAll wid="100%">
          <Text center marg="18px 0 0">
            {t('profile.followRequired', { teamName, feature })}
          </Text>
        </Col>
        <Row marg="30px 0 0" display="flex" justifyContent="center">
          <Button big bg={theme.SECONDARY} text={t('common.okay')} onClick={onClose} />
        </Row>
      </Col>
    </Modal>
  );
};

export default FollowRequiredModal;
